import { createQueryKeys } from '@lukemorales/query-key-factory';
import type { ItemDetailParams, ItemPageListParams } from '@module/apis/client-side/item/type';

export const itemQueryKeys = createQueryKeys('item', {
  fetchItemStoreItemList: () => ['fetchItemStoreItemList'],
  fetchGiftableItemList: () => ['fetchGiftableItemList'],
  fetchItemUse: () => ['fetchItemUse'],
  fetchMyItemList: (fetchMyItemListParams: ItemPageListParams) => [fetchMyItemListParams],
  fetchSendItemGift: () => ['fetchSendItemGift'],
  fetchSendPush: () => ['fetchSendPush'],
  fetchItemDetail: (params: ItemDetailParams) => [params],
});
